/**
 * @author xiaohuangmao
 * @date 2021-02-19
 * @desc 受众组新增/编辑
 */
import React from "react";
import { connect } from "dva";
import columns from "./columns";
import { framework_tool, component_tool,utils_tool } from "@/tool";
import { getDetailRecord } from "@/utils/commonUtils";
let { Session } = utils_tool;
const { WizCard, WizSpin, WizForm, WizEmpty } = component_tool;
const { WizContainer, modelUtils } = framework_tool;

const defaultValue = {
  orgIds: [],
  positionIds: [],
  positionCategoryIds: [],
  personIds: []
}

class AudienceGroupDetail extends WizContainer {

  componentName = "AudienceGroupPreview";

  constructor(props) {
    super(props);
    this.detailInfo={}
    const { history } = this.props;

    if (history.location && history.location.pathname === '/audience/group/upd') {
      if (history.location.record) {
        this.detailInfo = history.location.record;
        Session.set('audienceRecord', history.location.record)
      } else {
        this.detailInfo = Session.get('audienceRecord') || {};
      }
    }
    this.state = {
      managerScope: {},
      _key: '_key'
    };
    this.isUpd = props.location.pathname === '/audience/group/upd'
  }

  /**
   * ⭐ 只有路由配置时cached: true 才会有此生命周期, 且刷新逻辑需自行实现
   * 编辑时可能会触发重置,如果关键字id不同,则判定是新进入,将重新渲染表单
   */
  _componentDidRecover() {
    const { history } = this.props;
    let initialValue = {};
    if (history.location && history.location.pathname === '/audience/group/upd') {
      if (history.location.record) {
        initialValue = history.location.record;
        Session.set('audienceRecord', initialValue)
      } else {
        initialValue = Session.get('audienceRecord') || {};
      }
    }
    if (initialValue.id != this.detailInfo.id) {
      this.detailInfo = initialValue
      this._componentDidMount()
    }
  }

  _componentDidMount() {
    if(!this.isUpd) return
    this.doAction({
      path: "audienceGroup/editInfo",
      payload: {
        key: "audienceGroup@editInfo",
        apiParams: { id: this.detailInfo.id },
      },
    });
  }

   // 监听属性和状态的变化
   propsAndStateOnChange = {
    detail: this._detail.bind(this),
    editInfo: this._editInfo.bind(this),
  };

  _detail(nextProps, nextState) {
    const { detail, history } = nextProps;
    if (detail.success) {
      wizNotice.success(`${this.isUpd ? '编辑' : '新增'}成功!`)
      this.jumpPage('replaceAndDelCrumb', '/audience/group');
      // history.replace('/audience/group')
      return true;
    }
    wizNotice.error(detail.msg || `${this.isUpd ? '编辑' : '新增'}失败!`)
    return false;
  }

  _editInfo(nextProps, nextState) {
    const { editInfo } = nextProps;
    if (editInfo["success"] && editInfo["data"]) {
      nextState.managerScope = editInfo.data.managerScope
      nextState._key = new Date().getTime()
      return true;
    }
    wizNotice.error(editInfo.msg)
    return false;
  }

  formatScope = ({ orgIds = [], positionIds = [], positionCategoryIds = [], personIds = [] }) => ({
    orgIds: orgIds.map(val => val.id),
    positionIds: positionIds.map(val => val.id),
    positionCategoryIds: positionCategoryIds.map(val => val.id),
    personIds: personIds.map(val => val.id),
  })

  formatValues = values => ({
    ...values,
    groupScope: this.formatScope(values.groupScope || defaultValue),
    managerScope: this.formatScope(values.managerScope || defaultValue)
  })

  _sumbit(values) {
    const formatValues = this.formatValues(values)
    const api = this.isUpd ? 'upd' : 'add'
    this.doAction({
      path: `audienceGroup/${api}`,
      payload: {
        key: `audienceGroup@${api}`,
        apiParams: formatValues
      }
    })
  }

  render() {
    const { audienceGroupLoading } = this.props
    const { managerScope, _key } = this.state
    const onSubmit = this._sumbit.bind(this)

    const formProps = {
      key: this.detailInfo.id,
      ref: 'form',
      columns: columns({...this.detailInfo, managerScope}),
      onSubmit,
      record: null,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: {span: 4},
        wrapperCol: {span: 17}
      }
    }

    return (
      <WizCard title={(this.isUpd ? '修改': '新增') + '受众组'}>
        <WizSpin spinning={audienceGroupLoading}>
          <WizForm {...formProps} />
        </WizSpin>
      </WizCard>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const api = ownProps.location.pathname === '/audience/group/upd' ? 'upd' : 'add'
  const { audienceGroup } = state;
  const detail = modelUtils.getModelEntity(
    audienceGroup,
    `audienceGroup@${api}`
  );
  const editInfo = modelUtils.getModelEntity(
    audienceGroup,
    "audienceGroup@editInfo"
  );
  const load = modelUtils.getLoadingState(state, "audienceGroup");
  return {
    detail,
    editInfo,
    ...load,
  };
};

export default connect(mapStateToProps)(AudienceGroupDetail);
